import { isApiError } from '#shared/core/errors';

/** The server's own words when it has them ("Ana already has the app."), else ours. */
export function errorText(e: unknown, fallback: string): string {
  return isApiError(e) && e.message && e.status < 500 ? e.message : fallback;
}
